import { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  autoComplete?: string
  autoFocus?: boolean
  dataTestId?: string
  invalid?: boolean
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  /** Rendered inside the field on the trailing edge, e.g. a reveal toggle. */
  trailing?: ReactNode
  type: string
  value?: string
}

export default function FunnelInput({
  autoComplete,
  autoFocus = false,
  dataTestId,
  invalid = false,
  name,
  onChange,
  placeholder,
  trailing,
  type,
  value,
}: Props) {
  return (
    <div className="relative">
      <input
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        className={twMerge(
          'bg-hw-fill text-hw-ink placeholder:text-hw-muted/70 focus:border-hw-primary w-full rounded-2xl border-2 border-transparent px-4 py-4 text-base font-semibold transition-colors outline-none focus:bg-white',
          invalid && 'border-hw-red focus:border-hw-red',
          trailing && 'pr-12',
        )}
        data-testid={dataTestId}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        value={value}
      />

      {trailing && (
        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
          {trailing}
        </div>
      )}
    </div>
  )
}
